import { Component, computed, input } from '@angular/core';
import { ClIcon } from '@corelabs/angular/ui';
import { CircleCheck, IconNode, TriangleAlert } from 'lucide';

export type NoticeSeverity = 'warning' | 'success';

/** Washed box stating a consequence or an all-clear, with any detail projected under the message. */
@Component({
    selector: 'app-notice',
    templateUrl: './notice.component.html',
    styleUrls: ['./notice.component.css'],
    imports: [ClIcon],
    host: { '[class]': 'severity()' },
})
export class NoticeComponent {
    readonly message = input.required<string>();
    readonly severity = input<NoticeSeverity>('warning');

    readonly icon = computed<IconNode>(() => (this.severity() === 'success' ? CircleCheck : TriangleAlert));
}
